module.exports = __webpack_public_path__ + "img/Numberold.c457609a.svg";